<template>
    <input-text :type="visible ? 'text' : 'password'">
        <template #left>
            <slot name="left" />
        </template>

        <template #right>
            <button-link
                :aria-label="ariaLabel"
                theme="gray-dark"
                :icon="visible ? 'eye-slash' : 'eye-full'"
                :icon-size="20"
                type="button"
                @click.prevent="toggleVisibility"
            />
        </template>
    </input-text>
</template>

<script>
import ButtonLink from "~/components/buttons/ButtonLink"
import InputText from "~/components/inputs/InputText"

export default {
    data() {
        return {
            visible: false,
        }
    },

    computed: {
        ariaLabel() {
            if (this.visible) {
                return this.$t("common.hidePassword")
            } else {
                return this.$t("common.showPassword")
            }
        },
    },

    methods: {
        toggleVisibility() {
            this.visible = !this.visible
        },
    },

    components: {
        ButtonLink,
        InputText,
    },
}
</script>
